import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import duration from 'dayjs/plugin/duration';

dayjs.extend(relativeTime);
dayjs.extend(duration);

export const calculateTimeLeft = (deadline: Dayjs): { [key: string]: number } => {
  const now = dayjs();
  const timeDuration = dayjs.duration(deadline.diff(now));
  let timeLeft: { [key: string]: number } = {};

  if (timeDuration.asMilliseconds() > 0) {
    const totalDays = Math.floor(timeDuration.asDays());
    const totalHours = Math.floor(timeDuration.asHours());
    const totalMinutes = Math.floor(timeDuration.asMinutes());
    const totalSeconds = Math.floor(timeDuration.asSeconds());

    timeLeft = {
      weeks: Math.floor(totalDays / 7),
      days: totalDays % 7,
      hours: totalHours % 24,
      minutes: totalMinutes % 60,
      seconds: totalSeconds % 60,
    };
  }

  return timeLeft;
};
